<template>
  <div id="amend_info">
    <a-spin :spinning="spinning" size="large">
      <h3>待修正学生信息</h3>
      <div class="amend_box">
        <div class="two_part info_flex">
          <a-button class="empty_btn" @click="exportInfoHandle">导出错误学生信息</a-button>
          <a-button v-show="reviseFlag" type="danger" ghost @click="removeHandle">删除</a-button>
          <a-button v-show="reviseFlag" type="danger" ghost @click="emptyHandle">清空待修正学生列表</a-button>
        </div>
        <div v-if="errorTotalList">
          <a-table :columns="columns" :dataSource="errorTotalList" :rowKey="row => row.UID" :pagination="{ pageSize: 10, showSizeChanger: true, showQuickJumper: true }" :rowSelection="rowSelection">
            <template slot="SEX" slot-scope="text">{{text === 1 ? '男' : (text === 2 ? '女' : '未知') }}</template>
            <template slot="GRADE_ID" slot-scope="text">{{text ? gradeName(text) : '未知'}}</template>
            <template slot="CLASS_ID" slot-scope="text">{{text ? `${text}班` : '未知'}}</template>
            <template slot="STATUS" slot-scope="text">{{statusExplain(text)}}</template>
            <template slot="operation" slot-scope="text, record">
              <span class="action" @click="amendHandle(record.UID, record)">修正</span>
              <a-modal title="修正学生信息" v-if="record.UID === editUid" v-model="visible" @ok="hideModal" okText="修正学生信息" cancelText="取消">
                <div class="edit_box info_flex">
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学校：</span>
                  <span>{{teacherAdmin.school_name}}</span>
                </div>
                <div style="margin-top: 16px;">
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学生姓名：</span>
                  <a-input v-model="editName" placeholder="请输入" style="width: 250px" />
                </div>
                <div style="margin-top: 16px;">
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">性别：</span>
                  <a-select v-model="editSex" style="width: 250px" @change="editSexChange" placeholder="请选择">
                    <a-select-option v-for="(item, index) in editSexList" :key="index + 'c'" :value="item.id">{{item.val}}</a-select-option>
                  </a-select>
                </div>
                <div style="margin-top: 16px;">
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学籍号：</span>
                  <a-input v-model="editSocial" placeholder="请输入" style="width: 250px" />
                </div>
                <div style="margin-top: 16px;">
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">身份证号：</span>
                  <a-input v-model="editCard" placeholder="请输入" style="width: 250px" />
                </div>
                <div style="margin-top: 16px;">
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">年级：</span>
                  <a-select v-model="editGrade" style="width: 250px" @change="editGradeChange" placeholder="请选择">
                    <a-select-option v-for="(item, index) in editGradeList" :key="index + 'e'" :value="item.id">{{item.val}}</a-select-option>
                  </a-select>
                </div>
                <div style="margin-top: 16px;">
                  <span style="display: inline-block; width: 120px; text-align: right">班级：</span>
                  <a-select v-model="editClass" style="width: 250px" @change="editClassChange" placeholder="请选择">
                    <a-select-option v-for="(item, index) in editClassList" :key="index + 'd'" :value="item">{{`${item}班`}}</a-select-option>
                  </a-select>
                </div>
              </a-modal>
            </template>
          </a-table>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import GRADE from '@/util/grade'
import STUDENTFUN from '@/util/studentFun'
import XLSX from 'xlsx'

export default {
  name: 'AmendStudentInfo',
  data () {
    return {
      columns: [
        {
          title: '学生姓名',
          dataIndex: 'REAL_NAME',
          key: 'REAL_NAME'
        },
        {
          title: '性别',
          dataIndex: 'SEX',
          key: 'SEX',
          scopedSlots: { customRender: 'SEX' }
        },
        {
          title: '年级',
          dataIndex: 'GRADE_ID',
          key: 'GRADE_ID',
          scopedSlots: { customRender: 'GRADE_ID' }
        },
        {
          title: '班级',
          dataIndex: 'CLASS_ID',
          key: 'CLASS_ID',
          scopedSlots: { customRender: 'CLASS_ID' }
        },
        {
          title: '出现的问题',
          dataIndex: 'STATUS',
          key: 'STATUS',
          scopedSlots: { customRender: 'STATUS' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
        },
        onSelect: (record, selected, selectedRows) => {
          if (this.selectedRowKeys.length === 0) {
            this.reviseFlag = false
          } else {
            this.reviseFlag = true
          }
          console.log(record, selected, selectedRows)
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          if (this.selectedRowKeys.length === 0) {
            this.reviseFlag = false
          } else {
            this.reviseFlag = true
          }
          console.log(selected, selectedRows, changeRows)
        }
      },
      reviseFlag: false,
      errorOne: null,
      errorTwo: null,
      errorTotalList: null,
      selectedRowKeys: [],
      visible: false,
      editUid: null,
      editFlag: null,
      editName: null,
      editSex: null,
      editSocial: null,
      editCard: null,
      editGrade: null,
      editClass: null,
      editSexList: [{id: 1, val: '男'}, {id: 2, val: '女'}],
      editGradeList: null,
      editClassList: STUDENTFUN.classList,
      spinning: true
    }
  },
  computed: {
    ...mapState([
      'schoolInfos',
      'teacherAdmin',
      'errorStuList',
      'schoolGrades',
      'amendStuInfo'
    ])
  },
  async mounted () {
    await this.getErrorStu()
    if (this.errorStuList) {
      this.spinning = false
    }
    this.togetherErrorInfo()
    if (this.schoolGrades) {
      this.editGradeList = STUDENTFUN.editGradeReplace(this.schoolGrades)
    }
  },
  watch: {
    errorStuList () {
      this.togetherErrorInfo()
    }
  },
  methods: {
    ...mapActions([
      'getErrorStu',
      'removeAmendStu',
      'removeStuInfo',
      'getSchoolInfos',
      'updateAmendStu',
      'editStuInfo',
      'logAdd'
    ]),
    ...mapMutations([
      'setSelectKey'
    ]),
    gradeName (item) {
      return GRADE.gradeName(item)
    },
    togetherErrorInfo () {
      if (this.errorStuList) {
        this.errorOne = this.errorStuList
      }
      // if (this.schoolInfos) {
      //   this.errorTwo = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyError
      // }
      this.errorTotalList = [...this.errorOne]
    },
    amendHandle (key, value) {
      this.visible = true
      this.editUid = key
      this.editName = value.REAL_NAME
      this.editSex = value.SEX
      this.editFlag = value.flagNum ? value.flagNum : false
      if (value.STUDENT_ID_SOCIAL) {
        this.editSocial = value.STUDENT_ID_SOCIAL
      } else {
        this.editSocial = '暂无'
      }
      if (value.STUDENT_ID_CARD) {
        this.editCard = value.STUDENT_ID_CARD
      } else {
        this.editCard = '暂无'
      }
      this.editGrade = value.GRADE_ID ? this.gradeName(value.GRADE_ID) : '未知'
      this.editClass = value.CLASS_ID ? `${value.CLASS_ID}班` : '未知'
    },
    editSexChange (value) {
      this.editSex = value
    },
    editGradeChange (value) {
      this.editGrade = value
    },
    editClassChange (value) {
      this.editClass = `${value}班`
    },
    async hideModal () {
      // let moment = require('moment')
      if (this.editName && this.editSex && (this.editGrade && this.editGrade !== '未知')&& this.editClass && ((this.editCard && this.editCard !== '暂无' ) || (this.editSocial && this.editSocial !== '暂无'))) {
        let editResult = STUDENTFUN.editTest(this.editCard, this.editSocial, this.editSex)
        if (editResult === 'success') {
          console.log(this.editGrade)
          console.log(isNaN(this.editGrade))
          let dataList = {
            CLASS_ID: this.editClass.substring(0, this.editClass.length - 1),
            GRADE_ID: isNaN(this.editGrade) ? GRADE.gradeIdTwo(this.editGrade) : this.editGrade,
            REAL_NAME: this.editName,
            SEX: this.editSex,
            STUDENT_ID_SOCIAL: !this.editSocial || this.editSocial === '暂无' ? null : this.editSocial,
            STUDENT_ID_CARD: !this.editCard || this.editCard === '暂无' ? null : this.editCard,
            error_uid: this.editUid
          }
          await this.updateAmendStu(dataList)
          if (this.amendStuInfo) {
            this.visible = false
            this.$message.success('修正学生信息成功')
            await this.removeAmendStu({
              stuUids: [dataList.error_uid]
            })
            this.errorTotalList.map((itemOne, index) => {
              if (itemOne.UID === this.editUid) {
                this.errorTotalList.splice(index, 1)
              }
            })
            await this.getErrorStu()
            await this.getSchoolInfos({skip: 0})
          } else {
            this.$message.error('修正学生信息失败')
          }
          // if (this.editFlag) {
          //   // dataList[0]['TS'] = moment().format('YYYY-MM-DD HH:mm:ss')
          //   try {
          //     await this.editStuInfo({
          //       uid: this.editUid,
          //       result: dataList[0]
          //     })
          //     this.visible = false
          //     this.$message.success('修正学生信息成功')
          //     this.errorTotalList.map((itemOne, index) => {
          //       if (itemOne.UID === this.editUid) {
          //         this.errorTotalList.splice(index, 1)
          //       }
          //     })
          //     await this.getSchoolInfos({skip: 0})
          //     this.togetherErrorInfo()
          //   } catch (e) {
          //     this.$message.error('修正学生信息失败')
          //   }
          // } else {
          //   await this.updateAmendStu({
          //     data: dataList,
          //     errorUid: this.editUid
          //   })
          //   if (this.amendStuInfo) {
          //     this.visible = false
          //     this.$message.success('修正学生信息成功')
          //     this.errorTotalList.map((itemOne, index) => {
          //       if (itemOne.UID === this.editUid) {
          //         this.errorTotalList.splice(index, 1)
          //       }
          //     })
          //     await this.getErrorStu()
          //     await this.getSchoolInfos({skip: 0})
          //   } else {
          //     this.$message.error('修正学生信息失败')
          //   }
          // }
        }
        if (editResult === 2) {
          this.$message.warning('身份证号与所填写的性别不符，请核对')
        }
        if (editResult === 3) {
          this.$message.warning('学籍号超过20位了，请修改')
        }
        if (editResult === 5) {
          this.$message.warning('所输入的身份证号无效，请核对')
        }
      } else {
        if (!this.editName || !this.editSex || !this.editGrade || this.editGrade === '未知' || !this.editClass) {
          this.$message.warning('请将信息填写完整')
        }
        if ((this.editCard === '暂无' || !this.editCard) && (this.editSocial === '暂无' || !this.editSocial)) {
          this.$message.warning('学籍号与身份证至少填写一项')
        }
      }
    },
    statusExplain (info) {
      switch (info) {
        case 1:
          return '必填信息不完善'
        case 2:
          return '身份证有误'
        case 3:
          return '学籍号有误（只取英文，数字，长度限制20位）'
        case 4:
          return '身份证重复'
        case 5:
          return '学籍号重复'
      }
    },
    removeHandle () {
      let oneList = []
      // let twoList = []
      this.selectedRowKeys.map(item => {
        console.log(this.errorOne)
        this.errorOne.filter(itemOne => {
          if (itemOne.UID == item) {
            oneList.push([item])
          }
        })
        // this.errorTwo.filter(itemOne => {
        //   if (itemOne.UID === item) {
        //     twoList.push(item)
        //   }
        // })
      })
      this.$confirm({
        title: '删除待修正学生信息后不可恢复',
        content: '你还要继续吗',
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          if (oneList.length !== 0) {
            try {
              await this.removeAmendStu({
                stuUids: oneList
              })
              this.$message.success('删除成功')
              oneList.map(item => {
                // this.errorTotalList.map((itemOne, index) => {
                //   if (itemOne.UID === item) {
                //     this.errorTotalList.splice(index, 1)
                //   }
                // })
                this.selectedRowKeys.map((itemOne, index) => {
                  if (itemOne === item) {
                    this.selectedRowKeys.splice(index, 1)
                  }
                })
              })
              this.reviseFlag = false
              await this.getErrorStu()
            } catch (e) {
              console.log(e)
              this.$message.error('删除失败')
            }
          }
          // if (twoList.length !== 0) {
          //   let removeList = []
          //   twoList.map(item => {
          //     removeList.push({uid: item, status: 2})
          //   })
          //   try {
          //     await this.removeStuInfo({
          //       data: removeList
          //     })
          //     this.$message.success('删除成功')
          //     twoList.map(item => {
          //       // this.errorTotalList.map((itemOne, index) => {
          //       //   if (itemOne.UID === item) {
          //       //     this.errorTotalList.splice(index, 1)
          //       //   }
          //       // })
          //       this.selectedRowKeys.map((itemOne, index) => {
          //         if (itemOne === item) {
          //           this.selectedRowKeys.splice(index, 1)
          //         }
          //       })
          //     })
          //     this.reviseFlag = false
          //     await this.getErrorStu()
          //   } catch (e) {
          //     console.log(e)
          //     this.$message.error('删除失败')
          //   }
          // }
        },
        onCancel() {}
      })
    },
    emptyHandle () {
      let oneList = []
      // let twoList = []
      this.$confirm({
        title: '清空待修正学生信息后不可恢复',
        content: '你还要继续吗',
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          if (this.errorOne && this.errorOne.length !== 0) {
            this.errorOne.map(item => {
              oneList.push([item.UID])
            })
            try {
              await this.removeAmendStu({
                stuUids: oneList
              })
              this.$message.success('清空成功')
              this.selectedRowKeys = []
              // oneList.map(item => {
              //   this.errorTotalList.map((itemOne, index) => {
              //     if (itemOne.UID === item) {
              //       this.errorTotalList.splice(index, 1)
              //     }
              //   })
              // })
              this.reviseFlag = false
              await this.getErrorStu()
            } catch (e) {
              console.log(e)
              this.$message.error('清空失败')
            }
          }
          // if (this.errorTwo && this.errorTwo.length !== 0) {
          //   this.errorTwo.map(item => {
          //     twoList.push(item.UID)
          //   })
          //   try {
          //     await this.removeStuInfo({
          //       data: twoList
          //     })
          //     this.$message.success('清空成功')
          //     this.selectedRowKeys = []
          //     // twoList.map(item => {
          //     //   this.errorTotalList.map((itemOne, index) => {
          //     //     if (itemOne.UID === item.uid) {
          //     //       this.errorTotalList.splice(index, 1)
          //     //     }
          //     //   })
          //     // })
          //     this.reviseFlag = false
          //     await this.getErrorStu()
          //   } catch (e) {
          //     console.log(e)
          //     this.$message.error('清空失败')
          //   }
          // }
        },
        onCancel() {}
      })
    },
    async exportInfoHandle () {
      let finishData = []
      this.errorTotalList.map(item => {
        finishData.push({'姓名': item.REAL_NAME, '性别': item.SEX === 1 ? '男' : (item.SEX === 2 ? '女' : '未知'), '年级': this.gradeName(item.GRADE_ID), '班级': `${item.CLASS_ID}班`, '学籍号': item.STUDENT_ID_SOCIAL, '身份证号': item.STUDENT_ID_CARD})
      })
      let wb = {
        SheetNames: [],
        Sheets: { sheet1: 'ww' }
      }
      let ws = XLSX.utils.json_to_sheet(finishData)
      XLSX.utils.book_append_sheet(wb, ws, '待修正学生名单')
      XLSX.writeFile(wb, `待修正学生名单.xlsx`, { compression: true })
      await this.logAdd({
        name: '学生-待修正学生信息-导出错误学生信息',
        remarks: ''
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.setSelectKey('1')
    next()
  }
}
</script>

<style>
#amend_info {
  width: 100%;
  padding: 32px 0px 50px 24px;
  box-sizing: border-box;
}
#amend_info .amend_flex {
  display: flex;
  align-items: center;
}
#amend_info h3 {
  font-size: 24px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 24px;
}
#amend_info .amend_box {
  width: 100%;
  padding: 24px 0px 0px;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
}
#amend_info .amend_box .two_part {
  width: 100%;
  padding: 16px 24px 24px;
  box-sizing: border-box;
}
#amend_info .amend_box .two_part .ant-btn {
  margin-right: 16px;
}
#amend_info .action {
  cursor: pointer;
  color: #1890FF;
}
.ant-modal-confirm .ant-btn-primary {
  color: #FFFFFF;
  background-color: #51BF94;
  border-color: #51BF94;
}
.ant-modal-confirm .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
</style>
